import React from 'react'
import { ah, ReduxWrapper, compose } from 'common-data/datahelpers'

class CollapsiblePlain extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     open: false
  //   }
  //   this.togglePanel = this.togglePanel.bind(this)
  // }

  // togglePanel (e) {
  //   this.setState({ open: !this.state.open })
  // }

  componentDidUpdate () {

  }

  render () {
    const { isOpen, Title } = this.props
    return (<div>
      {Title === !undefined ? (
        <div onClick={(e) => this.togglePanel(e)} className='header'>
          {this.props.title}</div>
      ) : null
      }
      {isOpen === true ? (
        <div className='content'>
          {this.props.children}
        </div>
      ) : null}
    </div>)
  }
}
export const Collapsible = compose(
  ReduxWrapper([
  ], [
    ah.showConfirm
  ])
)(CollapsiblePlain)

export default Collapsible
